exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bs-numbers span{display:inline-block;padding:0 2px}.bs-numbers span.icon-point{transform:scale(.4) translateY(12px)}.bs-numbers .opacity-num{opacity:.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-83e11bee!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fragment/number/index.vue
// module id = 177
// module chunks = 0